module.exports = __webpack_public_path__ + "2b25a9b0525ba07c75561aac7738aa54.pdf";